import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import ticon1 from "../../../images/icon/flower-icon-blue.svg";

// Conference images
import scaiImg from "../../../images/testimonial/b1.png";
import futureOilImg from "../../../images/testimonial/b2.png";

const Testimonial = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);

  useEffect(() => {
    if (swiperRef.current && prevRef.current && nextRef.current) {
      swiperRef.current.params.navigation.prevEl = prevRef.current;
      swiperRef.current.params.navigation.nextEl = nextRef.current;
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, []);



  return (
    <section className="testimonial pt-150 pb-140">
      <div className="container">

        {/* HEADER */}
        <div className="da-sec-titlte text-center mb-60">
          <span className="sub_title">
            <span><img src={ticon1} alt="" /></span>
            Our Conferences
          </span>
          <h2 className="title">Upcoming & Live Events</h2>
        </div>

        <div className="da-testimonial-wrap pos-rel">
          <div className="da-testimonial-slider swiper-container">
            <div className="swiper-wrapper">

              <Swiper
                modules={[Navigation]}
                spaceBetween={50}
                slidesPerView={1}
                loop={true}
                speed={1800}
                parallax={true}
                ref={swiperRef}
                onBeforeInit={(swiper) => {
                  swiperRef.current = swiper;
                }}
              >

                     {/* ================= FUTURE OIL 2026 ================= */}
                <SwiperSlide className="da-testimonial">
                  <div className="row align-items-center mt-none-30">

                    <div className="col-lg-6 mt-30">
                      <div className="da-tes-left">

                        {/* BADGES — SAME STYLE */}
                        <div className="conf-badge-wrap">
                          <span className="conf-badge">Upcoming</span>
                          <span className="conf-badge conf-badge--virtual">
                            Virtual
                          </span>
                        </div>

                        <h2 className="xb-item--title">
                          Future Oil Conference 2026
                        </h2>

                        <p className="xb-item--content content--one">
                          AI, data, and digital transformation accelerating the
                          global transition toward net-zero energy systems.
                        </p>

                        <div className="xb-item--holder ul_li align-items-start">
                          <div className="xb-item--meta">
                            <h3 className="xb-item--number">21–22 April 2026</h3>
                            <span className="xb-item--text">
                              100% Virtual on Hubilo
                            </span>
                          </div>
                          <div className="xb-item--meta">
                            <h3 className="xb-item--number">Energy Leaders</h3>
                            <span className="xb-item--text">
                              Oil, gas, renewables & policy
                            </span>
                          </div>
                        </div>

                        <p className="xb-item--content content--two">
                          Future Oil 2026 brings together global energy executives,
                          policymakers, investors, and technology innovators to
                          examine how AI, big data, and digital platforms are
                          transforming energy production, efficiency, and sustainability.
                        </p>

                        <p className="xb-item--content content--three">
                          The conference focuses on digital transformation strategies,
                          decarbonization pathways, net-zero commitments, and
                          real-world use cases shaping the future energy ecosystem.
                        </p>

                        {/* CTA */}
                        <a
                          href="https://futureoilconference.com/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="conf-cta-btn"
                        >
                          Visit Conference Website
                          <i className="fal fa-long-arrow-right"></i>
                        </a>
                      </div>
                    </div>

                    <div className="col-lg-6 mt-30">
                      <div className="conf-image-card">
                        <img src={futureOilImg} alt="Future Oil Conference 2026" />
                      </div>
                    </div>

                  </div>
                </SwiperSlide>

                {/* ================= SCAI 2026 ================= */}
                <SwiperSlide className="da-testimonial">
                  <div className="row align-items-center mt-none-30">

                    <div className="col-lg-6 mt-30">
                      <div className="da-tes-left">

                        {/* BADGES */}
                        <div className="conf-badge-wrap">
                          <span className="conf-badge">Upcoming</span>
                          <span className="conf-badge conf-badge--virtual">
                            Virtual
                          </span>
                        </div>

                        <h2 className="xb-item--title">
                          Supply Chain Artificial Intelligence Conference 2026
                        </h2>

                        <p className="xb-item--content content--one">
                          Accelerating logistics and supply chain transformation through
                          artificial intelligence, automation, and real-time analytics.
                        </p>

                        <div className="xb-item--holder ul_li align-items-start">
                          <div className="xb-item--meta">
                            <h3 className="xb-item--number">16–17 Sept 2026</h3>
                            <span className="xb-item--text">
                              100% Virtual Conference
                            </span>
                          </div>
                          <div className="xb-item--meta">
                            <h3 className="xb-item--number">Global Audience</h3>
                            <span className="xb-item--text">
                              Enterprises, governments & investors
                            </span>
                          </div>
                        </div>

                        <p className="xb-item--content content--two">
                          Join global supply chain leaders, technology innovators,
                          policymakers, and solution providers as they explore how AI
                          is reshaping logistics, visibility, resilience, and
                          operational efficiency at scale.
                        </p>

                        <p className="xb-item--content content--three">
                          Topics include AI-driven forecasting, automation, robotics,
                          real-time analytics, and digital supply chain platforms
                          powering next-generation logistics networks.
                        </p>

                        {/* CTA */}
                        <a
                          href="https://supplychainaiconference.com/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="conf-cta-btn"
                        >
                          Visit Conference Website
                          <i className="fal fa-long-arrow-right"></i>
                        </a>
                      </div>
                    </div>

                    <div className="col-lg-6 mt-30">
                      <div className="conf-image-card">
                        <img src={scaiImg} alt="SCAI 2026 Conference" />
                      </div>
                    </div>

                  </div>
                </SwiperSlide>

           

              </Swiper>
            </div>
          </div>

          {/* NAV */}
          <div className="da-swiper-btn swiper-button-prev" ref={prevRef}>
            <i className="fal fa-long-arrow-left"></i>
          </div>
          <div className="da-swiper-btn swiper-button-next" ref={nextRef}>
            <i className="fal fa-long-arrow-right"></i>
          </div>
        </div>

    

      </div>
    </section>
  );
};

export default Testimonial;
